module.exports = __webpack_public_path__ + "static/media/wm_bg_morning.2fcf73b7.webp";